import React from 'react'
import { Grid, Button, Typography, makeStyles } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import ArrowBackIosNewTwoToneIcon from "@mui/icons-material/ArrowBackIosNewTwoTone";
import { APP_BAR_COLOR } from '../utils/constant';
import { connect } from "react-redux";

const useStyles = makeStyles(() => ({
	Typography: {
        padding: "1rem", textAlign: "justify",    lineHeight:"normal" 
	},
	
}));

 function TermsCondition(props) {

	const [storeInfo, setStoreInfo] = React.useState("");

  // const { reducer } = props;
  // const storeInfo = props.sessionReducer?.store_details;


  let StoreConfig = localStorage.getItem("jwt");
 let config=JSON.parse(StoreConfig)

React.useEffect(() => {
  setStoreInfo(config?.store)
}, [StoreConfig])


    const navigate = useNavigate();
    const classes = useStyles();
  return (
    <Grid style={{ background: "#f1f1f1", height: "100vh" }}>
    <Grid
      style={{
        padding: "0.8rem",
        boxShadow: "0px 0px 9px",
        background: "white",
      }}
    >
      <Button
        onClick={() => {
          navigate(-1);
        }}
        style={{
          position: "absolute",
          left: 0,
        }}
      >
        <ArrowBackIosNewTwoToneIcon />
      </Button>
      <Typography variant="h5" style={{ fontWeight: "bold" }}>
      Terms and Conditions
      </Typography>
    </Grid>

    <Grid style={{ padding: "1rem", marginTop: "1rem" ,maxHeight:"85vh",overflow:"scroll",scrollbarWidth:"none" }} >

    <Typography className={classes.Typography} > This document is an electronic record in terms of Information Technology Act, 2000 
                                        and rules there under as applicable and the amended provisions pertaining to electronic records in various 
                                        statutes as amended by the Information Technology Act, 2000. This electronic record is generated by a computer 
                                        system and does not require any physical or digital signatures.</Typography> 

                                        <Typography className={classes.Typography}> This document is published in accordance with the provisions of Rule 3 (1) of the 
                                        Information Technology (Intermediaries guidelines) Rules, 2011 that require publishing the rules 
                                        and regulations, privacy policy and Terms of Use for access or usage of <span style={{textTransform:"uppercase"}}> {storeInfo?.store_org_name} </span>
                                        , including the related mobile site and mobile application (hereinafter referred to as “Platform”)</Typography> 

                                        <Typography className={classes.Typography}>The Platform is owned and operated by <span style={{textTransform:"uppercase"}}> {storeInfo?.store_org_name} </span>, a company incorporated under the Companies Act, 1956, with its registered office in New Delhi, India. </Typography> 

                                        <Typography className={classes.Typography}> Your use of the Platform and services and tools are governed by the following terms 
                                        and conditions ('Terms of Use') as applicable to the Platform including the applicable policies which are 
                                        ncorporated herein by way of reference. If you transact on the Platform, you shall be subject to the 
                                        policies that are applicable to the Platform for such transaction. By mere use of the Platform, 
                                        you shall be contracting with <span style={{textTransform:"uppercase"}}> {storeInfo?.store_org_name} </span> and it is deemed that you have 
                                        accepted these terms and conditions including the policies which constitute your binding obligations, 
                                        with <span style={{textTransform:"uppercase"}}> {storeInfo?.store_org_name} </span>.</Typography> 

                                        <Typography className={classes.Typography}>For the purpose of these Terms of Use, wherever the context so requires 'You' or 'User' 
                                        shall mean any natural or legal person who has agreed to become a buyer on the Platform by providing 
                                        Registration Data while registering on the Platform as Registered User using the computer systems or 
                                        through any other device enabling the use of Information Technology. <span style={{textTransform:"uppercase"}}> {storeInfo?.store_org_name} </span> allows the User to surf 
                                        the Platform or making purchases without registering on the Platform. The term 'We', 'Us', 'Our' shall 
                                        mean <span style={{textTransform:"uppercase"}}> {storeInfo?.store_org_name} </span> </Typography> 
                                        <Typography className={classes.Typography}> When You use any of the services provided by Us through the Platform, including but 
                                        ot limited to, (e.g. Product Reviews), You will be subject to the rules, guidelines, policies, terms, 
                                        and conditions applicable to such service, and they shall be deemed to be incorporated into this Terms 
                                        of Use and shall be considered as part and parcel of this Terms of Use. We reserve the right, at Our 
                                        sole discretion, to change, modify, add or remove portions of these Terms of Use, at any time without 
                                        any prior written notice to You. It is Your responsibility to review these Terms of Use periodically 
                                        for updates / changes. Your continued use of the Platform following the posting of changes will mean 
                                        that You accept and agree to the revisions. As long as You comply with these Terms of Use, We grant 
                                        You a personal, non-exclusive, non-transferable, limited privilege to enter and use the Platform."</Typography> 

                                        <Typography>ACCESSING, BROWSING OR OTHERWISE USING THE SITE INDICATES YOUR AGREEMENT TO ALL 
                                        THE TERMS AND CONDITIONS UNDER THESE TERMS OF USE, SO PLEASE READ THE TERMS OF USE CAREFULLY BEFORE 
                                        PROCEEDING. By impliedly or expressly accepting these Terms of Use, You also accept and agree to be 
                                        bound by <span style={{textTransform:"uppercase"}}> {storeInfo?.store_org_name} </span> Policies (including but not limited to Privacy Policy  available at Website) as 
                                        amended from time to time.</Typography>


                                        <Typography className={classes.Typography} style={{fontWeight:"bold",paddingBottom:"0rem"}}> Communications </Typography> 
                                        <Typography className={classes.Typography}> When you use the Platform or send emails or other data, information or communication 
                                        to us, You agree and understand that You are communicating with Us through electronic records and You 
                                        consent to receive communications via electronic records from Us periodically and as and when required. 
                                        We may communicate with you by email or by such other mode of communication, electronic or otherwise.</Typography> 

                                        <Typography className={classes.Typography} style={{fontWeight:"bold",paddingBottom:"0rem"}}> Privacy Policy</Typography> 
                                        <Typography  className={classes.Typography}>We view protection of Your privacy as a very important principle. We understand clearly 
                                        that You and Your Personal Information is one of Our most important assets. We store and process Your 
                                        Information including any sensitive financial information collected (as defined under the Information 
                                            Technology Act, 2000), if any, on computers that may be protected by physical as well as reasonable 
                                            technological security measures and procedures in accordance with Information Technology Act 2000 and 
                                            Rules there under. Our current Privacy Policy is available at Website. If You object to Your Information 
                                            being transferred or used in this way please do not use Platform. </Typography> 

                                        <Typography className={classes.Typography}> We may share personal information with our other corporate entities and affiliates. These 
                                        entities and affiliates may market to you as a result of such sharing unless you explicitly opt-out. </Typography> 

                                        <Typography  className={classes.Typography}> We may disclose personal information to third parties. This disclosure may be required for 
                                        us to provide you access to our Services, to comply with our legal obligations, to enforce our User Agreement, 
                                        to facilitate our marketing and advertising activities, or to prevent, detect, mitigate, and investigate 
                                        fraudulent or illegal activities related to our Services. We do not disclose your personal information to 
                                        third parties for their marketing and advertising purposes without your explicit consent.</Typography>
                                        
                                        <Typography className={classes.Typography}> We may disclose personal information if required to do so by law or in the good faith 
                                        belief that such disclosure is reasonably necessary to respond to subpoenas, court orders, or other legal 
                                        process. We may disclose personal information to law enforcement offices, third party rights owners, or 
                                        others in the good faith belief that such disclosure is reasonably necessary to: enforce our Terms or Privacy 
                                        Policy; respond to claims that an advertisement, posting or other content violates the rights of a third party; 
                                        or protect the rights, property or personal safety of our users or the general public. </Typography> 

                                        <Typography className={classes.Typography}>We and our affiliates will share some or all of your personal information with another 
                                        business entity basis we (or our assets) plan to merge with, or be acquired by that business entity, 
                                        or re-organization, amalgamation, restructuring of business. Should such a transaction occur that other 
                                        business entity (or the new combined entity) will be required to follow this privacy policy with respect to 
                                        your personal information. </Typography> 


              

 
         <Typography
           className={classes.Typography}
           style={{ fontWeight: "bold", paddingBottom: "0rem" }}
         >
            
           Refund Policy
         </Typography>
         <ul>
           <li>
              
             <Typography
               className={classes.Typography}
               style={{ padding: "0.5rem" }}
             >
               You shall be entitled to a refund only if you pre-pay for your
               order at the time of placing your order on the Platform and only
               in the event of any of the following circumstances:
             </Typography>
           </li>
           <li>
              
             <Typography
               className={classes.Typography}
               style={{ padding: "0.5rem" }}
             >
               Your order packaging has been tampered or damaged at the time of
               delivery;
             </Typography>
           </li>
           <li>
              
             <Typography
               className={classes.Typography}
               style={{ padding: "0.5rem" }}
             >
                
               <span style={{textTransform:"uppercase"}}> {storeInfo?.store_org_name} </span> cancelling your order due to (A) your delivery location
               following outside our designated delivery zones; (B) failure to
               contact you by phone or email at the time of confirming the order
               booking;
             </Typography>
           </li>
           <li>
              
             <Typography
               className={classes.Typography}
               style={{ padding: "0.5rem" }}
             >
               You cancelling the order at the time of confirmation due to
               unavailability of the items you ordered for at the time of
               booking.
             </Typography>
           </li>
           <li>
              
             <Typography
               className={classes.Typography}
               style={{ padding: "0.5rem" }}
             >
               Our decision on refunds shall be at our sole discretion and shall
               be final and binding.
             </Typography>
           </li>
 
           <li><Typography className={classes.Typography}>All refund amounts shall be credited to your account within 5-7 working days in accordance with the terms that may be stipulated
               by the bank which has issued the credit / debit card.
             </Typography>
           </li>
         </ul>
         
         <Typography className={classes.Typography} style={{fontWeight:"bold",paddingBottom:"0rem"}}>Shipping Policy</Typography> 

         <Typography className={classes.Typography}  style={{paddingBottom:"0rem"}}>There is no Shipping Policy as the products/items are consumed at location and are not shipped to the customers.</Typography>

                                        {/* <Typography className={classes.Typography} style={{fontWeight:"bold",paddingBottom:"0rem"}}>Services</Typography>  */}

                                        <Typography className={classes.Typography} style={{fontWeight:"bold",paddingBottom:"0rem"}}>Payment</Typography> 
                                        <Typography className={classes.Typography}>While availing any of the payment method/s available on the Platform, we will not be 
                                        responsible or assume any liability, whatsoever in respect of any loss or damage arising directly or indirectly to You due to:</Typography> 
                                        <div className="pl-3 mb-2">
                                            <Typography className={classes.Typography}>Lack of authorization for any transaction/s, or</Typography> 
                                            <Typography className={classes.Typography}>Exceeding the preset limit mutually agreed by You and between 'Bank/s', or</Typography> 
                                            <Typography className={classes.Typography}>Decline of transaction for any other reason/s</Typography> 
                                        </div>
                                        <Typography className={classes.Typography}>All payments made against the purchases/services on Platform by you shall be compulsorily in Indian Rupees acceptable in the Republic of India. Platform will not facilitate transaction with respect to any other form of currency with respect to the purchases made on Platform.</Typography> 
                                        <Typography className={classes.Typography}>You have specifically authorized <span style={{textTransform:"uppercase"}}> {storeInfo?.store_org_name} </span> or its service providers to collect, process, facilitate and remit payments and / or the Transaction Price electronically or through Cash on Delivery to and from other Users in respect of transactions through Payment Facility.</Typography> 
                                        <Typography className={classes.Typography}>You understand, accept and agree that the payment facility provided by <span style={{textTransform:"uppercase"}}> {storeInfo?.store_org_name} </span> is neither a banking nor financial service but is merely a facilitator providing an electronic, automated online electronic payment, receiving payment through Cash On Delivery, collection and remittance facility for the Transactions on the <span style={{textTransform:"uppercase"}}> {storeInfo?.store_org_name} </span> Platform using the existing authorized banking infrastructure and Credit Card payment gateway networks. Further, by providing Payment Facility, <span style={{textTransform:"uppercase"}}> {storeInfo?.store_org_name} </span> is neither acting as trustees nor acting in a fiduciary capacity with respect to the Transaction or the Transaction Price.</Typography> 

                                        <Typography className={classes.Typography} style={{fontWeight:"bold",paddingBottom:"0rem"}}>Indemnity</Typography> 
                                        <Typography className={classes.Typography}>You shall indemnify and hold harmless <span style={{textTransform:"uppercase"}}> {storeInfo?.store_org_name} </span>, its owner, licensor, licensee, affiliates, subsidiaries, group companies (as applicable) and their respective officers, directors, agents, and employees, from any claim or demand, or actions including reasonable attorneys' fees, made by any third party or penalty imposed due to or arising out of Your breach of this Terms of Use, privacy Policy and other Policies, or Your violation of any law, rules or regulations or the rights (including infringement of intellectual property rights) of a third party.</Typography> 
                                        
                                        <Typography className={classes.Typography} style={{fontWeight:"bold",paddingBottom:"0rem"}}>Applicable Law</Typography> 
                                        <Typography className={classes.Typography}>Terms of Use shall be governed by and interpreted and construed in accordance with the laws of India. The place of jurisdiction shall be exclusively in Delhi.</Typography> 

                                        <Typography className={classes.Typography} style={{fontWeight:"bold",paddingBottom:"0rem"}}>Limitation of Liability</Typography> 
                                        <Typography className={classes.Typography}>IN NO EVENT SHALL <span style={{textTransform:"uppercase"}}> {storeInfo?.store_org_name} </span> BE LIABLE FOR ANY SPECIAL, INCIDENTAL, INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND IN CONNECTION WITH THESE TERMS OF USE, EVEN IF USER HAS BEEN INFORMED IN ADVANCE OF THE POSSIBILITY OF SUCH DAMAGES.</Typography> 

                                        <Typography className={classes.Typography} style={{fontWeight:"bold",paddingBottom:"0rem"}}>Contact Us</Typography> 
                                        <Typography className={classes.Typography}>Please contact us for any questions or comments or inquiries regarding this Platform.</Typography> 

        </Grid>



    </Grid>
  )
}
const mapStateToProps = (state) => {
  return {
    reducer: state.customerReducer,
  };
};

export default connect(mapStateToProps)(TermsCondition);